const DEFAULT_PROVIDER_SCOPE = 'openid profile email read:admin write:admin offline_access';

const toScopeSet = (scope) => new Set(
  String(scope || '')
    .split(/\s+/)
    .map((value) => value.trim())
    .filter(Boolean)
);

const isScopeCoveredByProvider = (requestedScope, providerScope = DEFAULT_PROVIDER_SCOPE) => {
  const requestedScopes = toScopeSet(requestedScope);
  if (requestedScopes.size === 0) {
    return true;
  }

  const providerScopes = toScopeSet(providerScope);
  return Array.from(requestedScopes).every((scope) => providerScopes.has(scope));
};

export const normalizeSilentTokenOptions = (options, providerDefaults = {}) => {
  if (!options || typeof options !== 'object') {
    return undefined;
  }

  const normalizedOptions = { ...options };
  const authorizationParams = options.authorizationParams && typeof options.authorizationParams === 'object'
    ? { ...options.authorizationParams }
    : null;

  if (authorizationParams) {
    const providerAudience = providerDefaults.audience ?? process.env.REACT_APP_AUTH0_AUDIENCE;
    const providerScope = providerDefaults.scope ?? DEFAULT_PROVIDER_SCOPE;

    if (!authorizationParams.audience || authorizationParams.audience === providerAudience) {
      delete authorizationParams.audience;
    }

    if (!authorizationParams.scope || isScopeCoveredByProvider(authorizationParams.scope, providerScope)) {
      delete authorizationParams.scope;
    }

    Object.keys(authorizationParams).forEach((key) => {
      if (authorizationParams[key] == null || authorizationParams[key] === '') {
        delete authorizationParams[key];
      }
    });

    if (Object.keys(authorizationParams).length === 0) {
      delete normalizedOptions.authorizationParams;
    } else {
      normalizedOptions.authorizationParams = authorizationParams;
    }
  }

  return Object.keys(normalizedOptions).length > 0 ? normalizedOptions : undefined;
};

export const getAccessTokenSilentlyWithProviderDefaults = (
  getAccessTokenSilently,
  options,
  providerDefaults
) => {
  const normalizedOptions = normalizeSilentTokenOptions(options, providerDefaults);
  return normalizedOptions
    ? getAccessTokenSilently(normalizedOptions)
    : getAccessTokenSilently();
};
